import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';

const QuickLinksView = ({ data }) => {
  const items = data.items || [];
  // QuickLinks representa, por definicao, o painel de atalhos do design
  // system. Conteudos antigos sem `variant` recebem o mesmo visual; uma
  // variacao explicitamente escolhida pelo editor continua prevalecendo.
  const variant = data.variant || 'panel';
  return (
    <section
      className={`ag-quicklinks-section${variant === 'panel' ? ' ag-quicklinks-section--panel' : ''}`}
    >
      {(data.title || data.description) && (
        <div className="ag-quicklinks-section__head">
          {data.title && (
            <h2 className="ag-quicklinks-section__heading">{data.title}</h2>
          )}
          {data.description && (
            <p className="ag-quicklinks-section__subtitle">
              {data.description}
            </p>
          )}
        </div>
      )}
      <div className="ag-quicklinks-grid">
        {items.map((item, idx) => (
          <UniversalLink
            key={idx}
            href={item.href || '#'}
            className="ag-quicklink"
          >
            <span className="ag-quicklink__label">{item.label}</span>
            {item.sublabel && (
              <span className="ag-quicklink__sublabel">{item.sublabel}</span>
            )}
            <svg
              className="ag-quicklink__arrow"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </UniversalLink>
        ))}
      </div>
    </section>
  );
};

QuickLinksView.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.array,
    variant: PropTypes.string,
  }).isRequired,
};

export default QuickLinksView;
